import React, { useState, useEffect, useRef } from "react";
import { Skeleton } from "@mui/material";
import ReactPaginate from "react-paginate";
import CurrencyConverter from "@heartinz/currency_subunit_converter";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";

import ViewPaylater from "./ViewPaylater";
import AddPaylater from "./AddPaylater";
import { usePermission } from "../../../context/PermissionContext";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import Table from "../../../constants/Table";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import { AddIcon, RefreshIcon, SearchIcon, ShowIcon } from "../../../constants/Icons";

const Paylater = ({ isActive }) => {
  // const [isBtnLoading, setBtnLoading] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState({
    payIn: false,
    payOut: false,
    listPaylater: false,
  });
  const [isPaylaterData, setPaylaterData] = useState([]);
  const [isSelectedPlater, setSelectedPlater] = useState(false);
  const [isAddPlaterModalOpen, setAddPlaterModalOpen] = useState(false);
  const { globelPopupOpen } = usePermission();

  const searchInputRef = useRef(null);
  const customerSuggestionsRef = useRef(null);
  const suggestionRefs = useRef([]);
  const containerRef = useRef(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [isSearchTerm, setSearchTerm] = useState("");
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [selectedCustomerPhone, setSelectedCustomerPhone] = useState("");
  const [suggestionLoading, setSuggestionLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 10;
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();

  const handleListPaylater = async (page = 0, term = "") => {
    try {
      if (!checkNetwork()) return;
      setLoading((prev) => ({ ...prev, listPaylater: true }));
      // const data = { searchtxt: term, pageno: page + 1, perpage: perPage };
      const response = await AxiosInstance.get(
        `module/paylater?pageno=${page + 1}&limit=${perPage}&searchtxt=${term}`,
      );

      const results = response.data.results || [];
      setPaylaterData(results);

      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, listPaylater: false }));
    }
  };

  const handleAddPaylater = async (AddData) => {
    try {
      if (!checkNetwork()) return;
      if (AddData.paymode === "PAYIN") {
        setLoading((prev) => ({ ...prev, payIn: true }));
      } else {
        setLoading((prev) => ({ ...prev, payOut: true }));
      }
      const data = {
        customerid: AddData.selectedCustomerId,
        amount: CurrencyConverter.toSubunit(
          AddData.amount[AddData.index] || 0,
          "INR",
        ),
        paymode: AddData.paymode,
        paymentmode: AddData.paymentmode,
      };
      const response = await AxiosInstance.post(`module/paylater`, data);
      handleListPaylater();
      CloseAddPlater();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, payIn: false }));
      setLoading((prev) => ({ ...prev, payOut: false }));
    }
  };

  const handleSearch = async (term) => {
    setSearchTerm(term);
    setHasSearched(true);
    setSelectedCustomerPhone("");
    if (!term.trim()) {
      setCustomerSuggestions([]);
      await handleListPaylater(0, "");
      setCurrentPage(0);
      return;
    }
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        if (!checkNetwork()) return;
        setSuggestionLoading(true);

        controllerRef.current = new AbortController();

        const response = await AxiosInstance.get(
          `module/paylater/search?searchtxt=${term}`,
          { signal: controllerRef.current.signal },
        );

        setCustomerSuggestions(response.data.results || []);
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
        return false;
      } finally {
        setSuggestionLoading(false);
      }
    }, 200);
  };

  const handleSearchFind = () => {
    const currentInputValue = searchInputRef.current?.value || "";
    setSearchTerm(currentInputValue);
    setSelectedCustomerPhone("");
    if (!currentInputValue.trim()) {
      handleListPaylater(0, "");
    } else {
      handleListPaylater(0, currentInputValue);
    }
    setCustomerSuggestions([]);
    setHasSearched(false);
    setCurrentPage(0);
  };

  const handleSelectCustomer = (customer) => {
    const phone = customer.phone;
    setSearchTerm(phone);
    setSelectedCustomerPhone(phone);
    setCustomerSuggestions([]);
    setHasSearched(false);
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    handleListPaylater(0, phone);
    setCurrentPage(0);
  };

  const handleOutsideClick = (e) => {
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target)
    ) {
      setCustomerSuggestions([]);
      setHasSearched(false);
    }
  };

  const openAddPlaterModal = () => {
    // setDeleteData(cItem);
    setAddPlaterModalOpen(true);
  };

  const CloseAddPlater = () => {
    setAddPlaterModalOpen(false);
  };

  const handleView = (customer) => {
    setSelectedPlater(customer);
  };

  const handleClose = () => {
    setSelectedPlater(false);
  };

  const handleDataUpdate = () => {
    handleListPaylater(currentPage, isSearchTerm);
  };

  const handleAddData = async (AddData) => {
    // console.log("working", AddData);
    await handleAddPaylater(AddData);
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        setShowCustomerDropdown(false);
        setHighlightedIndex(-1);
      }
    }
  };

  useKeyboardTableNavigation({
    isActive,
    containerRef,
    searchTerms: isSearchTerm,
    suggestions: customerSuggestions,
    modals: {
      isAddPlaterModalOpen,
      isSelectedPlater,
      globelPopupOpen,
    },
    onEnter: handleView,
  });

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRefs.current[highlightedIndex]) {
      suggestionRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    handleListPaylater(currentPage, isSearchTerm);
  }, [currentPage]);

  const handleRefresh = async () => {
    await handleListPaylater(currentPage, isSearchTerm);
  };

  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="page-breadcrumb d-flex align-items-center mb-3 gap-2">
          <div className="pb-1">
            <button
              type="button"
              className="btn btn-sm btn-light p-1 shadow-none"
              onClick={handleRefresh}
              disabled={loading.listPaylater}
              title="Refresh list"
            >
              <RefreshIcon iClass={`${
                loading.listPaylater ? "bx-spin" : ""
              }`}/>
            </button>
          </div>
          <div className="breadcrumb-title pe-3">List Paylater</div>
        </div>

        <div className="row">
          <div className="col">
            <div className="card radius-10 mb-0">
              <div className="card-body px-0">
                <div className="row px-3">
                  <div className="col-lg-5 col-12">
                    <div className="position-relative">
                      <div className="input-group" ref={customerSuggestionsRef}>
                        <input
                          type="text"
                          className="form-control"
                          ref={searchInputRef}
                          onChange={(e) => {
                            handleSearch(e.target.value);
                            setShowCustomerDropdown(true);
                            setHighlightedIndex(-1);
                          }}
                          onKeyDown={handleCustomerKeyDown}
                          onFocus={() => {
                            if (customerSuggestions.length > 0) {
                              setShowCustomerDropdown(true);
                            }
                          }}
                          placeholder="Search customer by name, phone, email..."
                          autoFocus
                        />
                        <button
                          className="input-group-text"
                          onClick={handleSearchFind}
                        >
                          <SearchIcon/>
                        </button>
                      </div>

                      {hasSearched &&
                        isSearchTerm &&
                        !suggestionLoading &&
                        customerSuggestions.length === 0 && (
                          <ul className="suggestions-list">
                            <li className="suggestion-item text-muted">
                              No customers data was found
                            </li>
                          </ul>
                        )}

                      {showCustomerDropdown &&
                        customerSuggestions.length > 0 && (
                          <ul className="suggestions-list">
                            {customerSuggestions.map((customer, index) => (
                              <li
                                ref={(el) =>
                                  (suggestionRefs.current[index] = el)
                                }
                                key={customer._id}
                                onClick={() => handleSelectCustomer(customer)}
                                className={`suggestion-item ${
                                  highlightedIndex === index
                                    ? "highlighted"
                                    : ""
                                }`}
                              >
                                {customer.name} -
                                <span className="badge bg-label-blue rounded-pill ms-1">
                                  {customer.phone}
                                </span>
                                {customer.referenceid && (
                                  <>
                                    <small>-</small>
                                    <span className="badge bg-label-secondary rounded-pill ms-1">
                                      {customer.referenceid}
                                    </span>
                                  </>
                                )}
                              </li>
                            ))}
                          </ul>
                        )}
                    </div>
                  </div>
                  <div className="col-lg-2  col-6 d-flex align-items-center">
                    <div>
                      <strong>Total Paylater:</strong>{" "}
                      <span className="badge btn-label-primary fs-15 ">
                        {totalItems || 0}
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-5 col-6 d-flex justify-content-end ">
                    <button
                      type="button"
                      onClick={openAddPlaterModal}
                      className="btn btn-primary mt-2 mt-lg-0"
                    >
                      <AddIcon/> New PayLater
                    </button>
                  </div>
                </div>

                <div ref={containerRef}>
                  <Table
                    loading={loading.listPaylater}
                    data={isPaylaterData}
                    columns={[
                      {
                        label: "S.No",
                        tdBodyclass:"p-2",
                        render: (_, index) => (
                          <>{currentPage * perPage + index + 1}</>
                        ),
                      },
                      {
                        label: "Name",
                        key: "name",
                      },
                      {
                        label: "Phone",
                        render: (item) => (
                          <span className="text-heading fw-medium">
                            +91 {item?.phone}
                          </span>
                        ),
                      },
                      {
                        label: "Balance(₹)",
                        render: (item) => (
                          <div className="no-print position-relative">
                          <div className=" d-flex justify-content-center align-items-center">
                          <span className="stock-status-badge fw-medium fs-15">
                            {(() => {
                              const closeAmount = item?.paylaterBalance ?? 0;
                              return closeAmount >= 0 ? (
                                <span className="badge rounded-pill bg-label-success text-plus">
                                  {formatCurrencyFun(closeAmount)}
                                </span>
                              ) : (
                                <span className="badge rounded-pill bg-label-danger text-minus">
                                  {formatCurrencyFun(closeAmount)}
                                </span>
                              );
                            })()}
                          </span>
                          <div className="order-actions order-actions3 opacity-0 opacity-md-100">
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleView(item);
                              }}
                              className="btn-label-info shadow-none me-2"
                            >
                              <ShowIcon/>
                            </button>
                          </div>
                          </div>
                          </div>
                        ),
                      },
                      // {
                      //   label: "Actions",
                      //   render: (item) => (
                      //     <div className="order-actions opacity-0 opacity-md-100">
                      //       <button
                      //         type="button"
                      //         onClick={(e) => {
                      //           e.stopPropagation();
                      //           handleView(item);
                      //         }}
                      //         className="btn-label-info shadow-none me-2"
                      //       >
                      //         <i className="bx bx-show"></i>
                      //       </button>
                      //     </div>
                      //   ),
                      // },
                    ]}
                    onRowClick={(item, index) => handleView(item, index)}
                  />
                </div>
                {totalPages > 0 && (
                  <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                      previousLabel={"← Previous"}
                      nextLabel={"Next →"}
                      breakLabel={"..."}
                      onPageChange={({ selected }) => {
                        setLoading((prev) => ({ ...prev, listPaylater: true }));
                        // setIsLoading(true);
                        setCurrentPage(selected);
                      }}
                      pageRangeDisplayed={5}
                      pageCount={totalPages}
                      containerClassName="pagination"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      activeClassName="active"
                      forcePage={currentPage}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {isSelectedPlater && (
          <ViewPaylater
            isData={isSelectedPlater}
            onClose={handleClose}
            isActive={isActive}
            // isBtnLoading={isBtnLoading}
            onDataUpdate={handleDataUpdate}
          />
        )}
        {isAddPlaterModalOpen && (
          <AddPaylater
            isActive={isActive}
            onClose={CloseAddPlater}
            isBtnLoading={loading}
            onAdd={handleAddData}
          />
        )}
      </div>
    </div>
  );
};

export default Paylater;
